import { createApi } from '@reduxjs/toolkit/query/react';

import { apiFormsImages } from '~constants/api';
import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

/**
 * Upload for the rich-text image feature (TAV-3155). Deliberately the only endpoint here: the
 * matching read is NOT an RTK Query endpoint. Display resolves `data-form-image` references to
 * blob URLs via `downloadFile` (see `formImageResolver.ts`), because RTK Query would own the
 * object URL's cache lifetime independently of `URL.revokeObjectURL`, which is exactly the leak
 * component-scoped resolution avoids. No `tagTypes`: uploaded images are never listed or refetched.
 */
export const formImagesApi = createApi({
  reducerPath: 'formImagesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiFormsImages }),
  endpoints: (builder) => ({
    uploadFormImage: builder.mutation<{ id: string }, FormData>({
      query: (formData) => ({ url: '', method: 'POST', body: formData }),
      transformResponse: (payload) => unwrap<{ id: string }>(payload),
    }),
  }),
});

export const { useUploadFormImageMutation } = formImagesApi;
